// Externals
import React, { useCallback } from "react";

// Styles
// $FlowFixMe
import "./YesNo.scss";

/*::
type Props = {
	value: string,
    setStateValue: function,
    questionNumber: string,}
*/

// Yes/No Field Component
const YesNo = (props /*: Props */) /*: any */ => {
	const handleClick = useCallback(
		(option) => {
			props.setStateValue(option);
		},
		[props],
	);

	return (
		<div className={"yes-no question-" + props.questionNumber}>
			<button
				data-cy={"yes-" + props.questionNumber}
				onClick={() => handleClick("Yes")}
				className={props.value === "Yes" ? "selected" : null}
			>
				Yes
			</button>
			<button
				data-cy={"no-" + props.questionNumber}
				onClick={() => handleClick("No")}
				className={props.value === "No" ? "selected" : null}
			>
				No
			</button>
		</div>
	);
};

// Exports
export default YesNo;
